import { formatDateIso } from '../../dateTime';

import { fetchChannelProgramsQuery as fetchChannelPrograms } from './fetchChannelProgramsQuery';

export async function fetchChannelNextProgram({ channelId, endDate }: { channelId: number; endDate: number }) {
  const programs = await fetchChannelPrograms({ channelId, day: formatDateIso(endDate) });

  return programs.find((program) => !program.isNotFound && program.startDate === endDate);
}
